export const CREATE_TRANSACTION_ATTRIBUTES_CONSTANT = {
  sourceCountry: {
    type: 'select',
    key: 'source_country',
    label: 'Source Country',
  },
  destCountry: {
    type: 'select',
    key: 'destination_country',
    label: 'Destination Country',
  },
  transferType: {
    type: 'select',
    key: 'transfer_type_po',
    label: 'Transfer Type',
  },
  serviceLevel: {
    type: 'select',
    key: 'service_level',
    label: 'Service Level',
  },
  sourceOfIncome: {
    type: 'select',
    key: 'source_of_income',
    label: 'Source of Income',
  },
  purpose: {
    type: 'select',
    key: 'purpose',
    label: 'Purpose of Remittance',
  },
  paymentType: {
    type: 'select',
    key: 'payment_type_pi',
    label: 'Payment Type',
  },
  firstName: {
    type: 'text',
    key: 'first_name',
    label: 'Sender First Name',
  },
  middleName: {
    type: 'text',
    key: 'middle_name',
    label: 'Sender Middle Name',
  },
  lastName: {
    type: 'text',
    key: 'last_name',
    label: 'Sender Last Name',
  },
  address1: {
    type: 'text',
    key: 'address1',
    label: 'Sender Address',
  },
  city: {
    type: 'text',
    key: 'city',
    label: 'Sender City',
  },
  country: {
    type: 'text',
    key: 'nationality',
    label: 'Sender Country',
  },
  postalCode: {
    type: 'text',
    key: 'postal_code',
    label: 'Sender Postal Code',
  },
  email: {
    type: 'email',
    key: 'email',
    label: 'Sender Email',
  },
  mobileCode: {
    type: 'text',
    key: 'mobile_code',
  },
  mobileNumber: {
    type: 'tel',
    key: 'mobile_number',
    label: 'Sender Mobile',
  },
  // New-sender (inline) fields required by createSenderTransaction / addSender.
  gender: {
    type: 'select',
    key: 'gender',
    label: 'Sender Gender',
  },
  password: {
    type: 'password',
    key: 'password',
    label: 'Password',
  },
  dob: {
    type: 'date',
    key: 'date_of_birth',
    label: 'Sender Date of Birth',
  },
  pin: {
    type: 'text',
    key: 'pin',
    label: 'PIN',
  },
  address2: {
    type: 'text',
    key: 'address2',
    label: 'Sender Address 2',
  },
  town: {
    type: 'text',
    key: 'town',
    label: 'Sender Town',
  },
  docType: {
    type: 'select',
    key: 'document_type',
    label: 'ID Type',
  },
  docSection: {
    type: 'select',
    key: 'document_section',
    label: 'ID Section',
  },
  docNumber: {
    type: 'text',
    key: 'document_number',
    label: 'ID Number',
  },
  docExpiryDate: {
    type: 'date',
    key: 'document_expiry_date',
    label: 'ID Expiry Date',
  },
  image: {
    type: 'file',
    key: 'image',
    label: 'ID Document Scan',
  },
  beneFirstName: {
    type: 'text',
    key: 'bene_first_name',
    label: 'Recipient First Name',
  },
  beneMiddleName: {
    type: 'text',
    key: 'bene_middle_name',
    label: 'Recipient Middle Name',
  },
  beneLastName: {
    type: 'text',
    key: 'bene_last_name',
    label: 'Recipient Last Name',
  },
  beneAddress: {
    type: 'text',
    key: 'bene_address',
    label: 'Recipient Address',
  },
  beneCity: {
    type: 'text',
    key: 'bene_city',
    label: 'Recipient City',
  },
  benePostCode: {
    type: 'text',
    key: 'bene_post_code',
    label: 'Recipient Postal Code',
  },
  beneCountry: {
    type: 'select',
    key: 'benificiary_country',
    label: 'Recipient Country',
  },
  beneEmail: {
    type: 'email',
    key: 'bene_email',
    label: 'Recipient Email',
  },
  beneMobileCode: {
    type: 'text',
    key: 'bene_mobile_code',
  },
  beneMobileNumber: {
    type: 'tel',
    key: 'bene_mobile_number',
    label: 'Recipient Mobile',
  },
  sourceCurrency: {
    type: 'select',
    key: 'source_currency',
    label: 'Source Currency',
  },
  sourceAmount: {
    type: 'number',
    key: 'source_amount',
    label: 'Source Amount',
  },
  destCurrency: {
    type: 'select',
    key: 'destination_currency',
    label: 'Destination Currency',
  },
  destAmount: {
    type: 'number',
    key: 'destination_amount',
    label: 'Destination Amount',
  },
  headOfficeFee: {
    type: 'number',
    key: 'headOfficeFee',
    label: 'Head Office Fee',
  },
  commission: {
    type: 'number',
    key: 'commission',
    label: 'Commission',
  },
  rate: {
    type: 'number',
    key: 'rate',
    label: 'Rate',
  },
} as const;
